
import ViewResultCardComponent from "@/views/Covid/ViewResultCard/ViewResultCardComponent";
export default ViewResultCardComponent;
